<p-toast (click)="onToastClick()" />
<p-confirmDialog styleClass="confirm-dilouge"></p-confirmDialog>
<ngx-ui-loader
  overlayColor="transparent"
  [bgsOpacity]="1"
  fgsType="circle"
  fgsColor="#014E45"
  pbColor="#014E45"
  [fgsSize]="50"
  [pbThickness]="1"
/>
<router-outlet />